function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.582 19.436a1.25 1.25 0 00-1.164 0L7.036 21.74c-.917.482-1.989-.297-1.814-1.318l.837-4.88a1.25 1.25 0 00-.36-1.107L2.155 10.98c-.742-.723-.332-1.983.693-2.132l4.9-.712c.407-.059.759-.314.94-.683l2.192-4.44c.459-.93 1.783-.93 2.242 0l2.191 4.44c.182.369.534.624.941.683l4.9.712c1.025.15 1.435 1.41.693 2.133L18.3 14.434a1.25 1.25 0 00-.36 1.107l.838 4.88c.175 1.021-.897 1.8-1.814 1.318l-4.382-2.304z",
  fill: "#000"
});

function SvgStarFilled(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgStarFilled;